"use client";
import React, { useRef, useMemo } from "react";
import { IncognitoIcon } from "@cmp-src/icons/icons";
import { ImpersonateWidget } from "@/providers/impersonation/ImpersonateWidget";
import { IconButton } from "@cmp-src/primitives/icon-button/IconButton";
import { Circle } from "lucide-react";
import { cn } from "@gettactic/helpers";
import { roundButtonClassNames } from "../MainSidebar";
import { useImpersonateContext } from "@/providers/ImpersonateProvider";

export const ImpersonationButton: React.FC = () => {
  const {
    isSidebarButtonEnabled,
    isWidgetVisible,
    toggleWidget,
    isBeingImpersonated,
    canImpersonate,
    setIsWidgetVisible
  } = useImpersonateContext();

  const impersonateButtonRef = useRef<HTMLButtonElement>(null);

  const isShowingImpersonationButton = useMemo(
    () => (canImpersonate || isBeingImpersonated) && isSidebarButtonEnabled,
    [canImpersonate, isBeingImpersonated, isSidebarButtonEnabled]
  );

  if (!isShowingImpersonationButton) {
    return null;
  }

  return (
    <div>
      <div className="relative">
        {isBeingImpersonated && (
          <div className="pointer-events-none absolute inset-0 z-0">
            <Circle className="h-full w-full animate-ping text-red-500/50" />
          </div>
        )}
        <IconButton
          ref={impersonateButtonRef}
          icon={<IncognitoIcon />}
          variant="secondary"
          size="md"
          iconClassName={cn("size-[20px]", isBeingImpersonated && "text-white")}
          className={cn(
            roundButtonClassNames,
            "relative z-10",
            isBeingImpersonated &&
              "bg-red-500 text-white hover:bg-red-600 hover:text-white hover:ring-red-600"
          )}
          onClick={toggleWidget}
          aria-label="Impersonation"
        />
      </div>

      <ImpersonateWidget
        triggerRef={impersonateButtonRef}
        isVisible={isWidgetVisible}
        onClose={() => setIsWidgetVisible(false)}
      />
    </div>
  );
};
